export const SOFTLINE_FEATURE_KOMMISSIONIERUNG = 'kommissionierung';
export const SOFTLINE_PERMISSION_KOMMISSIONIERUNG = 'SOFTAPPS.LAGER.KOMMISSIONIERUNG';
export const SOFTLINE_PERMISSION_VORKOMMISSIONIERUNG =
  'SOFTAPPS.LAGER.VORKOMMISSIONIERUNG';
